import Model from '@newspaces/zero-base/Model';
import Runtime from '@newspaces/zero-base/Runtime';
import AccessCredential from './AccessCredential.js';
import 'nanoid';
import '@newspaces/zero-base/DateTime';
import '@blueid/access-proto';
import './Organisation.js';
import 'nanoid/generate';
import '@newspaces/zero-base/models/Organisation';
import '@newspaces/zero-base/utils';
import '../AccessSite-5abc043f.js';
import '../AccessCountries-3e45c6a9.js';
import '../AccessGroup-4a811995.js';
import './AccessTimeSchedule.js';
import '../i18n.js';
import '@newspaces/zero-base/i18n';
import '../canRemoveDocuments-3b897618.js';
import '../parseChangeSet-03074a6b.js';
import './AccessObject.js';
import '../AccessDevice-68531278.js';
import './AccessConfiguration.js';
import './AccessVendor.js';

class CustomPermissions extends Model {
  static Fields = {
    accessSites: {
      type: [Runtime.BSON.ObjectId]
    },
    accessCredentialTypes: {
      type: [String],
      enum: AccessCredential.Fields.credentialType.enum
    }
  };
  constructor(data) {
    super(CustomPermissions.Fields, data);
  }
}

export { CustomPermissions as default };
//# sourceMappingURL=CustomPermissions.js.map
